export function SortArrayByProperty(property: any) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a: any, b: any) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

export function SortArrayByParentCode(data: any) {
  let arr: any = []
  data.forEach((elem: any) => {
    let checkExist = arr.findIndex((o: any) => o.value == elem.parentCode)
    if (checkExist !== -1) {
      elem.isChild = true
      arr.splice(checkExist + 1, 0, elem)
    } else {
      let checkParent = arr.findIndex((o: any) => o.parentCode == elem.value)
      if (checkParent !== -1) {
        arr[checkParent].isChild = true
        arr.splice(checkParent, 0, elem)
      } else arr.push(elem)
    }
  })
  return arr
}
